import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';
import bnTranslation from './locales/bn/translation.json';
import enServitor from './locales/servitorsite/en/translation.json';
import bnServitor from './locales/servitorsite/bn/translation.json';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation, servitor: enServitor },
      bn: { translation: bnTranslation, servitor: bnServitor}
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'bn'],

    ns: ['translation','servitor'],       // <-- register both namespaces
    defaultNS: 'translation',            // <-- keep user-site “translation” as default
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18next;